export default {
      id: "ic_player_off-usage",
      viewBox: "0 0 17 17",
      url: "/" + "images/icons.3.109.2.svg#ic_player_off-usage",
      toString: function () {
        return this.url;
      }
    }